import Button from "../Atoms/Button";
import InputField from "../Atoms/InputField";
import TextField from "../Atoms/TextField";
import styles from "../../Styles/NoteEditModal.module.css";
import { useDispatch } from "react-redux";
import { noteActions } from "../../../Store/note-slice";
import { useState } from "react";

const NoteEditModal = ({ exitModal, deleteNote, saveChanges, note }) => {
  const [noteInfo, setNoteInfo] = useState({
    title: note.noteTitle,
    text: note.noteText,
    id: note.noteId,
  });
  const dispatch = useDispatch();

  const noteTitleHandler = (titleValue) => {
    setNoteInfo({ ...noteInfo, title: titleValue });
  };
  const noteTextHandler = (textValue) => {
    setNoteInfo({ ...noteInfo, text: textValue });
  };

  const noteEditedHandler = (e) => {
    e.preventDefault();
    dispatch(
      noteActions.setSelectedNote({
        noteId: noteInfo.id,
        noteTitle: noteInfo.title,
        noteText: noteInfo.text,
      })
    );
    saveChanges(noteInfo);
  };

  return (
    <div className={styles.modal}>
      <form className={styles.modal__form} onSubmit={noteEditedHandler}>
        <div className={styles.modal__form__inputTitle}>
          <InputField
            input={noteTitleHandler}
            label={note.noteTitle}
            initialValue={note.noteTitle}
          />
        </div>
        <div className={styles.modal__form__inputText}>
          <TextField
            theme={true}
            text={noteTextHandler}
            description={note.noteText}
            initialText={note.noteText}
          />
        </div>
        <div className={styles.modal__form__actions}>
          <Button>Save Changes</Button>
        </div>
      </form>
      <div className={styles.modal__actions}>
        <Button clicked={exitModal}>Exit Edit Mode</Button>
        <Button clicked={() => deleteNote(noteInfo.id)}>Delete Note</Button>
      </div>
    </div>
  );
};

export default NoteEditModal;
